export default __webpack_public_path__ + "static/media/blockchain-management.0b8c8b22.svg";